module.exports = __webpack_public_path__ + "img/inventoryWastage.79deae17.png";